import React from 'react';
import { Box } from '@mui/material';
import moment from 'moment';
import TextInputField from '../TextInputField';
import StyledText from '../Text/styles';

export interface DateRange {
	startDate: moment.Moment | null;
	endDate: moment.Moment | null;
}

interface Props {
	dateRange: DateRange;
	onChange: (date: DateRange) => void;
}

export default function DateRangePicker({ dateRange, onChange }: Props) {
	const handleStartDateChange = (_: string, date: string) => {
		const newRange: DateRange = {
			startDate: moment(date),
			endDate: dateRange.endDate,
		};
		if (moment(date).isAfter(dateRange.endDate)) {
			newRange.endDate = null;
		}
		onChange(newRange);
	};

	const handleEndDateChange = (_: string, date: string) => {
		const newRange: DateRange = {
			startDate: dateRange.startDate,
			endDate: moment(date),
		};
		if (moment(date).isBefore(dateRange.startDate)) {
			newRange.startDate = null;
		}
		onChange(newRange);
	};

	return (
		<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
			<TextInputField
				type="date"
				value={dateRange.startDate?.format('YYYY-MM-DD') ?? ''}
				onChange={handleStartDateChange}
				name="startDate"
				hasError={false}
				css={{
					'&>input': {
						fontSize: '12px',
					},
				}}
			/>
			<StyledText variant="body2">hasta</StyledText>
			<TextInputField
				type="date"
				value={dateRange.endDate?.format('YYYY-MM-DD') ?? ''}
				onChange={handleEndDateChange}
				name="endDate"
				hasError={false}
				css={{
					'&>input': {
						fontSize: '12px',
					},
				}}
			/>
		</Box>
	);
}
